<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">Application Feature Search</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> Application Feature Search</span>
                        <button  *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important; 
                        margin-top: -2px;border-color: white;" pButton  type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right"  (click)="addFeatureDetails()"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>


  <section id="gridID">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
  
                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                          
                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>
                      </div>
                      <div class="col-md-8">
  
                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;"  *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportFeatures()"
                           ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>
  
                          <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button>
                          
  
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>






<section>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12" *ngIf="isFeatureAdd || isFeatureEdit">
                    <div class="card">
                        <div class="devcare-card-header">
                            <span class="devcare-card-title">{{title}}</span>
                        </div>
                        <div class="devcare-card-body">
                            <div class="row">
                                <div class="col-md-9">
                                    <form [formGroup] = "featureForm">
                                    <div class="p-fluid p-formgrid p-grid">
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="featureName">Feature Name<span class="required-field">*</span></label>
                                            <input id="featureName" type="text" formControlName="featureName" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-5">
                                            <label for="description">Feature Description<span class="required-field">*</span></label>
                                            <input id="description" type="text" formControlName="description" pInputText>
                                        </div>
                                        <div class="p-field p-col-12 p-md-2">
                                            <label for="isActive">Is Active</label>
                                            <br />
                                            <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                        </div>
                                    </div>
                                </form>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <button pButton pRipple type="button" label="{{buttonLabel}}" icon="pi pi-check"
                                class="p-button-sm p-button-raised p-button-success m-2" [disabled]="!this.featureForm.valid" (click)="save(featureForm)"></button>
                            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                                class="p-button-sm p-button-raised p-button-danger m-2" (click)="cancel()"></button>

                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <!-- <div class="devcare-table-card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <button pButton type="button" class="p-button-raised p-button-sm m-2" label="Add"
                                    icon="pi pi-plus" (click)="addFeatureDetails()" *ngIf="(isFeatureAdd === false) && (isFeatureEdit === false) && sharedService.checkPermission('Admin_Add')"></button>
                                </div>
                                <div class="col-md-6">
                                </div>
                            </div>
                        </div> -->
                        <div class="devcare-table-card-header" *ngIf="showToggle">
                            <div class="row">
                                <div class="col-md-6">
            
                                </div>
                                <div class="col-md-6">
                                <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                                    <ng-template let-column pTemplate="item">
                                        <div class="column-item">
                                            <div>{{column.header}}</div>
                                        </div>
                                    </ng-template>
                                </p-multiSelect>
                                </div>
                            </div>
                        </div>
                        <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                            <p-table #dt2 [value]="featureList" [lazy]="true" paginatorDropdownAppendTo="body"
                                (onLazyLoad)="loadFeatureList($event)" dataKey="id" [rows]="10"
                                [showCurrentPageReport]="true"  [resizableColumns]="true" columnResizeMode="expand"
                                [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines"
                                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [globalFilterFields]="['featureName','description','isActive','createdBy','createdOn']">
                                <!-- <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                        <col>
                                    </colgroup>
                                </ng-template> -->
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action</th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('featureName')">Feature Name  <span pSortableColumn="featureName" *ngIf="showSorting"><p-sortIcon field="featureName"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="featureName" display="menu" #filterFeatureName [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #featureName type="text" value="{{filters?.featureName[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(featureName.value);applyFilterNew(dt2);filterFeatureName.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('description')">Feature Code  <span pSortableColumn="description" *ngIf="showSorting"><p-sortIcon field="description"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="description" display="menu" #filterDescription [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #description type="text" value="{{filters?.description[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(description.value);applyFilterNew(dt2);filterDescription.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('isActive')">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="isActive" display="menu" #filterIsActive [showAddButton]="false"
                                                [showMatchModes]="false"   [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <!--<input #isActive type="text" value="{{filters?.isActive[0]?.value}}" pInputText class="pinputHeight">-->
                                                    <p-dropdown #isActive [options]="statusValues" [(ngModel)] ="selectedStatusId" (onChange)="getStatusOnChange($event)"></p-dropdown>
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="clearStatus();filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(isActive.value);applyFilterNew(dt2);filterIsActive.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>

                                            
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdBy')">Created By  <span pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" field="createdBy" display="menu" #filterCreatedBy [showAddButton]="false"
                                                [showMatchModes]="true" [matchModeOptions]="matchModeOptions" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                    <input #createdBy type="text" value="{{filters?.createdBy[0]?.value}}" pInputText class="pinputHeight">
                                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdBy.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply</p-button>
                                                    </div>
                                                </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        <th pResizableColumn style="width: 14rem" *ngIf="isShowColumns('createdOn')">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                            <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" #filterCreatedOn [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                            [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                                <p-calendar #createdOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                                                <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                                    <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                                    <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply</p-button>
                                                </div>
                                            </ng-template>
                                            </p-columnFilter>
                                        </th>
                                        
                                    </tr>
                                    <tr [hidden]="!showFilters">
                                        <th *ngIf="isShowColumns('action')"></th>
                                        <th *ngIf="isShowColumns('featureName')">{{filters?.featureName[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('description')">{{filters?.description[0]?.value}}</th>
                                        <!--<th *ngIf="isShowColumns('isActive')">{{filters?.isActive[0]?.value}}</th>-->
                                        <th *ngIf="isShowColumns('isActive')">{{selectedStatus}}</th>
                                        <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value}}</th>
                                        <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value| date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                                    </tr>
                                </ng-template>
                               
                                <ng-template pTemplate="body" let-featureList>
                                    <tr>
                                        <td *ngIf="isShowColumns('action')"> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                                    (click)="selectedGridMenuItem = featureList; menu.toggle($event)"></i></a>
                                            <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                                        </td>
                                        <td *ngIf="isShowColumns('featureName')"><span class="table-col-featureName">{{featureList.featureName}}</span></td>
                                        <td *ngIf="isShowColumns('description')"><span>{{featureList.description}}</span></td>
                                        <td style="width: 8rem" *ngIf="isShowColumns('isActive')"><span class="customer-badge status-active" *ngIf="featureList.isActive">Active</span>
                                            <span class="customer-badge status-inactive" *ngIf="!featureList.isActive">Inactive</span>
                                        </td>
                                        <td *ngIf="isShowColumns('createdBy')"><span>{{featureList?.createdByUser?.firstName}}</span></td>
                                        <td *ngIf="isShowColumns('createdOn')"><span>{{featureList.createdOn | date:'MM/dd/yyyy'}} </span></td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="5">No Features found.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                </div>
            </div>
        </div>
    </div>
    <p-toast position="bottom-center"></p-toast>
</section>







<!-- 
  <section>
    <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">

            <div class="col-md-12" *ngIf="isFeatureAdd || isFeatureEdit">
                <div class="card">
                    <div class="devcare-card-header">
                        <span class="devcare-card-title">{{title}}</span>
                    </div>
                    <div class="devcare-card-body">
                        <div class="row">
                            <div class="col-md-9">
                                <form [formGroup] = "featureForm">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-5">
                                        <label for="featureName">Feature Name<span class="required-field">*</span></label>
                                        <input id="featureName" type="text" formControlName="featureName" pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-5">
                                        <label for="description">Feature Description</label>
                                        <input id="description" type="text" formControlName="description" pInputText>
                                    </div>
                                    <div class="p-field p-col-12 p-md-2">
                                        <label for="isActive">Is Active</label>
                                        <br />
                                        <p-inputSwitch id="isActive" formControlName="isActive"></p-inputSwitch>
                                    </div>
                                </div>
                            </form>
                            </div>
                            <div class="col-md-3 d-flex align-items-center">
                                <button pButton pRipple type="button" label="buttonLabel" icon="pi pi-check"
                            class="p-button-sm p-button-raised p-button-success m-2" ></button>
                        <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
                            class="p-button-sm p-button-raised p-button-danger m-2"></button>

                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>

            <div class="card">
                <div class="devcare-card-body">
                 
                  
                  <div class="row" *ngIf="showTopFilters">
                      
                      <div class="col-md-2 d-flex align-items-center">
                          <button pButton pRipple type="button" label="Save Filter" icon="pi pi-search"
                              class="p-button-sm p-button-raised m-2" style="height: 30px;" (click)="saveFilter()"></button>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                      </div>
                      <div class="col-md-8">

                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;"
                           ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>

                          <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button>
                          
                          <button class="p-button-raised m-2" label ="Add" pButton type="button" icon="pi pi-filter" (click)="addFeatureDetails()"
                           style="float: right;height: 30px;" *ngIf="(isFeatureAdd === false) && (isFeatureEdit === false)"></button>

                          
                      </div>
                  </div>
                </div>
            </div>
        </div>
        <div class="col-md-1"></div>
    </div>
</section> -->



<!-- 
<section>
  <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
          <div class="card">
              <div class="devcare-table-card-header">
                  
              </div>
              <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                  <p-table #dt2 [value]="applicationFeaturesList" dataKey="id" [rows]="10" [sortOrder]="0" 
                  [lazy] = "true" (onLazyLoad)="loadApplicationFeaturesList($event)"
                  [showCurrentPageReport]="true" [resizableColumns]="true" 
                  [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-customers" 
                      [paginator]="true" [totalRecords]="totalRecords"
                      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                      [globalFilterFields]="['featureName','description', 'isActive', 'createdBy' , 'createdOn']">
                      
                      
                      <ng-template pTemplate="header">
                          <tr>
                              <th style="width: 12rem">Feature Name  <span pSortableColumn="featureName" *ngIf="showSorting"><p-sortIcon field="featureName"></p-sortIcon></span>
                                  <p-columnFilter *ngIf="showFilters" type="text" field="featureName" display="menu" [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions"  [showClearButton]="false" [showApplyButton]="false">
                                  </p-columnFilter>
                              </th>
                              <th style="width: 12rem">Description <span pSortableColumn="description" *ngIf="showSorting"><p-sortIcon field="description"></p-sortIcon></span>
                                  <p-columnFilter *ngIf="showFilters" type="text" field="description" display="menu" [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                  </p-columnFilter>
                              </th>
                              <th style="width: 8rem">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                  <p-columnFilter *ngIf="showFilters" type="boolean" display="menu" field="isActive" 
                                  [showClearButton]="false" [showApplyButton]="false">
                                  </p-columnFilter>
                              </th>
                              <th style="width: 12rem">Created By <span pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                  <p-columnFilter *ngIf="showFilters" type="text" field="createdBy" display="menu" [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                  </p-columnFilter>
                              </th>
                              <th style="width: 12rem">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                  <p-columnFilter *ngIf="showFilters" type="date" field="createdOn" display="menu" [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                  </p-columnFilter>
                              </th>
                              <th style="width: 12rem">Action</th>
                          </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-applicationFeaturesList>
                          <tr>
                              <td><span class="table-col-featureName">{{applicationFeaturesList.featureName}}</span></td>
                              <td><span>{{applicationFeaturesList.description}}</span></td>
                              <td style="width: 8rem"><span class="customer-badge status-active" *ngIf="applicationFeaturesList.isActive">Active</span>
                                  <span class="customer-badge status-inactive" *ngIf="!applicationFeaturesList.isActive">Inactive</span>
                              </td> 
                              <td><span>{{applicationFeaturesList?.createdByUser?.firstName}}</span></td>
                              <td><span>{{applicationFeaturesList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                              <td>
                                  <span>
                                      <a [routerLink]="" class="table-icon table-icon-edit" style="color: #a4c4d8;"><i class="fas fa-edit"></i></a>&nbsp;&nbsp;
                                      <a [routerLink]="" class="table-icon" style="color: #ca86a8;" (click)="deleteConfirm(applicationFeaturesList.featureId)"><i class="fas fa-trash-alt"></i></a>&nbsp;&nbsp;
                                  </span>
                              </td>
                          </tr> 
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                          <tr>
                              <td colspan="5">No Application Features found.</td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
          </div>
      </div>
      <div class="col-md-1"></div>
  </div>
  <p-toast></p-toast>
</section> -->